module.exports = __webpack_public_path__ + "static/media/chevron-up-solid.3b30c822.svg";